import { FunctionComponent } from 'react'
import styled from 'styled-components'

import Spacer from 'components/Spacer'

import { hiddenContactSellerFormStatuses } from 'data/listingStatusGroupings'

import * as T from 'types'

import { formatAddress } from '../../../utils/listingHelpers'
import ContactForm from '../../ContactForm'

const hiddenStatuses: string[] = Object.values(hiddenContactSellerFormStatuses)

const Container = styled.div`
  padding: 20px;
  background: ${props => props.theme.colors.grey2};
  display: flex;
  flex-direction: column;
`

const StyledHeader = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  color: ${props => props.theme.colors.black};
`

interface IProps {
  listing: T.IListing
}

const ContactSeller: FunctionComponent<IProps> = ({ listing }) => {
  const isContactable = !!listing.contactInfo?.email || !!listing.secondaryContactInfo?.email
  const showModule = !hiddenStatuses.includes(listing.listingStatus.name) && isContactable

  if (!showModule) return null

  return (
    <Container>
      <StyledHeader>Contact Seller</StyledHeader>
      <Spacer size={8} />
      <ContactForm
        listingId={listing._id}
        formType="buyerInquiry"
        dismissAfter={60000}
        messageHeading="Message"
        messagePlaceholder="Ask a Question..."
        requirePhone
        submitText="Contact Seller"
        listingAddress={formatAddress(listing)}
      />
    </Container>
  )
}

export default ContactSeller
